import { Component, ojs, app, payload, v, each } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import {
	monetary,
	empty,
	insertSpaces,
	oneOf,
	either,
	inform,
	eParse,
	isMobile,
	cleanDispose,
} from "../../helpers";
import { STRINGS } from "../../declarations";
import SolidIcon from "../Blocks/SolidIcon";
import BsIcon from "../Blocks/BsIcon";
import { $e } from "../../ojs.events";

const h = app("h");
const api = app("api");
const broker = app("broker");
const dc = app("dc");
const purCxt = app("purCxt");

ojs(SolidIcon, BsIcon);

export default class PurchaseForm extends Component {
	holder = null;

	renderForm(...args) {
		const userCurrency = window.userCurrency;

		return h.div(
			{ class: "p-2" },
			h.div(
				{ class: "text-center mb-4" },
				h.h4({ class: "fw-bold text-dark mb-1" }, "Complete Purchase"),
				h.span(
					{ class: "text-muted small" },
					`Paying for ${Object.keys(dc.selectedItems.value).length} selected item${
						Object.keys(dc.selectedItems.value).length < 2 ? "" : "s"
					}`
				)
			),

			h.div(
				{ class: "d-flex gap-3 flex-column mb-3" },
				v(dc.buyFromSomewhereElse, (buyFromSomewhereElse) => {
					// We only require purchase location if any selected item is:
					// bought from somewhere else AND is not buying another item.
					const selectedItems = dc.selectedItems.value;
					let requiresLocation = false;
					for (let itemId in selectedItems) {
						const isSomewhereElse = buyFromSomewhereElse.value[itemId] === true;
						const buyAnother = dc.buyAnotherItem.value[itemId] === true;
						if (isSomewhereElse && !buyAnother) {
							requiresLocation = true;
							break;
						}
					}

					if (!requiresLocation) {
						return "";
					}

					return h.div(
						{ class: "d-flex flex-column gap-2" },
						h.div(
							{ class: "d-flex flex-column gap-2" },
							h.button(
								{
									class: "btn btn-outline-primary d-flex align-items-center justify-content-center gap-2 py-2.5 rounded-3 w-100",
									onclick: this.method("showMap"),
								},
								h.i({ class: "bi bi-geo-alt-fill" }),
								h.span({ class: "fw-semibold" }, "Where are you buying From?")
							),

							h.div(
								{
									class: "p-3 bg-light text-secondary rounded-3 text-center border border-light-subtle small",
									id: "pf-address-preview",
								},
								oneOf(
									"No Address Selected"
								)
							)
						),

						h.div(
							h.input({ type: "hidden", id: "puf-latitude" }),
							h.input({ type: "hidden", id: "puf-longitude" })
						)
					);
				}),
				
				// Premium Amount Card
				h.div(
					{ class: "p-3 bg-light rounded-3 text-center border border-light-subtle mb-2" },
					h.span({ class: "text-muted fs-xsm text-uppercase fw-bold d-block mb-1" }, "Total Amount"),
					h.span(
						{ id: "purchase-final-amount", class: "fs-3 fw-bold text-success" },
						monetary(this.getFinalAmount(), userCurrency)
					)
				),

				h.div(
					{
						class: "form-check form-switch d-none",
						onclick: this.method("switchType"),
					},

					h.input({
						class: "form-check-input",
						type: "checkbox",
						id: "purchase-type-switch",
					}),
					h.label(
						{
							class: "form-check-label",
							for: "purchase-type-switch",
						},
						"Pay Offline"
					)
				),

				h.div(
					{ class: "form-check form-switch d-none" },

					h.input({
						class: "form-check-input",
						type: "checkbox",
						id: "purchase-add-subtract-switch",
						onclick: this.method("addAmount"),
					}),
					h.label(
						{
							class: "form-check-label",
							for: "purchase-add-subtract-switch",
						},
						"Subtract"
					)
				),

				h.div(
					{ class: "input-group d-none" },
					h.span(
						{
							class: "input-group-text",
							id: "purchase-add-subtract-amount-label",
						},
						"Add: "
					),
					h.input({
						type: "number",
						class: "form-control",
						aria_label: "purchase-add-subtract-amount-label",
						aria_describedby: "purchase-add-subtract-amount-label",
						id: "purchase-add-subtract-amount-input",
						oninput: this.method("addAmount"),
					}),
					h.span(
						{
							class: "input-group-text",
							id: "purchase-add-subtract-amount-currency",
						},
						userCurrency
					)
				)
			),
			h.nav(
				h.div(
					{
						class: "nav nav-pills nav-fill gap-2 p-1 bg-light rounded-3 mb-3 border border-light-subtle",
						id: "mpesa-purchase-nav-tab",
						role: "tablist",
					},
					h.button(
						{
							class: "nav-link rounded-2 py-2 fw-semibold",
							id: "mpesa-purchase-till-tab",
							data_bs_toggle: "tab",
							data_bs_target: "#mpesa-purchase-till",
							type: "button",
							role: "tab",
							aria_controls: "mpesa-purchase-till",
							aria_selected: "true",
							data_mpesa_type: true,
							data_mpesa_value: "till",
						},
						"Till",
						either(purCxt.paymentInfo.mpesaType == "till", {
							class: "active",
						})
					),

					h.button(
						{
							class: "nav-link rounded-2 py-2 fw-semibold",
							id: "mpesa-purchase-phone-tab",
							data_bs_toggle: "tab",
							data_bs_target: "#mpesa-purchase-phone",
							type: "button",
							role: "tab",
							aria_controls: "mpesa-purchase-phone",
							aria_selected: "false",
							data_mpesa_type: true,
							data_mpesa_value: "phone",
						},
						"Phone",
						either(purCxt.paymentInfo.mpesaType == "phone", {
							class: "active",
						})
					),
					h.button(
						{
							class: "nav-link rounded-2 py-2 fw-semibold",
							id: "mpesa-purchase-paybill-tab",
							data_bs_toggle: "tab",
							data_bs_target: "#mpesa-purchase-paybill",
							type: "button",
							role: "tab",
							aria_controls: "mpesa-purchase-paybill",
							aria_selected: "false",
							data_mpesa_type: true,
							data_mpesa_value: "paybill",
						},
						"Paybill",
						either(purCxt.paymentInfo.mpesaType == "paybill", {
							class: "active",
						})
					)
				)
			),

			h.div(
				{
					class: "tab-content mb-3",
					id: "nav-tabContent",
				},
				h.div(
					{
						class: "tab-pane fade",
						id: "mpesa-purchase-till",
						role: "tabpanel",
						aria_labelledby: "mpesa-purchase-till-tab",
					},
					either(purCxt.paymentInfo.mpesaType == "till", {
						class: "show active",
					}),

					h.div(
						{ class: "input-group mt-2 shadow-sm" },
						h.span(
							{
								class: "input-group-text bg-white border-secondary-subtle fw-semibold text-secondary",
								id: "mpesa-purchase-till-label",
							},
							"Till:"
						),
						h.input(
							{
								type: "number",
								class: "form-control border-secondary-subtle py-2.5 fw-semibold text-dark",
								id: "mpesa-purchase-till-input",
								aria_label: "mpesa-purchase-till-label",
								aria_describedby: "mpesa-purchase-till-label",
								placeholder: "6566776",
							},
							either(purCxt.paymentInfo.mpesaType == "till", {
								value: purCxt.paymentInfo.mpesaInfo.till.number,
							})
						)
					)
				),
				h.div(
					{
						class: "tab-pane fade",
						id: "mpesa-purchase-paybill",
						role: "tabpanel",
						aria_labelledby: "mpesa-purchase-paybill-tab",
					},
					either(purCxt.paymentInfo.mpesaType == "paybill", {
						class: "show active",
					}),
					h.div(
						{ class: "input-group mt-2 shadow-sm" },
						h.span(
							{
								class: "input-group-text bg-white border-secondary-subtle fw-semibold text-secondary",
								id: "mpesa-purchase-paybill-label",
							},
							"Paybill:"
						),
						h.input(
							{
								type: "number",
								class: "form-control border-secondary-subtle py-2.5 fw-semibold text-dark",
								aria_label: "mpesa-purchase-paybill-label",
								aria_describedby:
									"mpesa-purchase-paybill-label",
								id: "mpesa-purchase-paybill-input",
								placeholder: "123456",
							},
							either(purCxt.paymentInfo.mpesaType == "paybill", {
								value: purCxt.paymentInfo.mpesaInfo.paybill
									.number,
							})
						)
					),
					h.div(
						{ class: "input-group mt-2 shadow-sm" },
						h.span(
							{
								class: "input-group-text bg-white border-secondary-subtle fw-semibold text-secondary",
								id: "mpesa-purchase-paybill-account-label",
							},
							"A/C:"
						),
						h.input(
							{
								type: "text",
								class: "form-control border-secondary-subtle py-2.5 fw-semibold text-dark",
								id: "mpesa-purchase-paybill-account-input",
								aria_label:
									"mpesa-purchase-paybill-account-label",
								aria_describedby:
									"mpesa-purchase-paybill-account-label",
								placeholder: "Account Number",
							},
							either(purCxt.paymentInfo.mpesaType == "paybill", {
								value: purCxt.paymentInfo.mpesaInfo.paybill
									.account,
							})
						)
					)
				),
				h.div(
					{
						class: "tab-pane fade",
						id: "mpesa-purchase-phone",
						role: "tabpanel",
						aria_labelledby: "mpesa-purchase-phone-tab",
					},
					either(purCxt.paymentInfo.mpesaType == "phone", {
						class: "show active",
					}),
					h.div(
						{ class: "input-group mt-2 shadow-sm" },
						h.span(
							{
								class: "input-group-text bg-white border-secondary-subtle fw-semibold text-secondary",
								id: "mpesa-purchase-phone-label",
							},
							"Phone:"
						),
						h.input(
							{
								type: "number",
								class: "form-control border-secondary-subtle py-2.5 fw-semibold text-dark",
								aria_label: "mpesa-purchase-phone-label",
								aria_describedby: "mpesa-purchase-phone-label",
								id: "mpesa-purchase-phone-input",
								placeholder: "0749675543",
							},
							either(purCxt.paymentInfo.mpesaType == "phone", {
								value: purCxt.paymentInfo.mpesaInfo.phone
									.number,
							})
						)
					)
				),
				h.div(
					{
						class: "tab-pane fade",
						id: "mpesa-purchase-transaction",
						role: "tabpanel",
						aria_labelledby: "mpesa-purchase-transaction-tab",
					},
					either(purCxt.paymentInfo.mpesaType == "transaction", {
						class: "show active",
					}),
					h.div(
						{ class: "input-group mt-2 shadow-sm" },
						h.span(
							{
								class: "input-group-text bg-white border-secondary-subtle fw-semibold text-secondary",
								id: "mpesa-purchase-transaction-label",
							},
							"ID:"
						),
						h.input(
							{
								type: "text",
								class: "form-control border-secondary-subtle py-2.5 fw-semibold text-dark",
								aria_label: "mpesa-purchase-transaction-label",
								aria_describedby:
									"mpesa-purchase-transaction-label",
								id: "mpesa-purchase-transaction-input",
								placeholder: "TA123453MRB",
								oninput: this.method(
									"parseTransactionId",
									"${this}"
								),
							},
							either(
								purCxt.paymentInfo.mpesaType == "transaction",
								{
									value: purCxt.paymentInfo.mpesaInfo
										.transaction.number,
								}
							)
						)
					)
				)
			),

			h.div(
				{ class: "d-none", id: "purchase-offline-with-mpesa" },
				h.label(
					{ class: "form-label", for: "offline-transaction-id" },
					"Mpesa Transaction ID"
				),
				h.input({
					class: "form-control",
					placeholder: "Mpesa Transaction ID",
					id: "offline-transaction-id",
					oninput: this.method("parseTransactionId", "${this}"),
				}),
				h.span(
					{ class: "form-text" },
					"Copy and Paste the Mpesa SMS here"
				)
			),

			h.div(
				{ class: "d-flex justify-content-end gap-3 fs-5 mt-4" },
				h.button(
					{
						class: "btn btn-outline-secondary rounded-3 px-4 py-2.5 fw-semibold",
						onclick: this.method("closeForm"),
					},
					"Cancel"
				),
				h.button(
					{
						class: "btn btn-success rounded-3 px-4 py-2.5 fw-bold shadow-sm flex-fill",
						id: "puf-make-purchase-btn",
						onclick: this.method("makePurchase", ["${this}"]),
					},
					"Confirm Purchase"
				)
			),

			...args
		);
	}

	$$purchase = {
		stored: (ed, event) => {
			this.closeForm();
		},

		needs: {
			form: (ed, event) => this.showForm(ed),
		},

		has: {
			storageError: (ed, event) => {
				const btn = dom.id("puf-make-purchase-btn");
				dom.enable(btn);
				dom.put("Purchase", btn);
			},
		},
	};

	async showForm(ed, event) {
		if (Object.keys(dc.selectedItems.value).length == 0) {
			inform(`Please select items to purchase`, STRINGS.WARNING);
			return;
		}

		let data = eParse(ed);

		if (this.holder) {
			cleanDispose(this.holder);
		}

		if (isMobile()) {
			this.holder = tool.offcanvas(
				h.PurchaseFormCanvas(
					this.renderForm(data.message.get("request"))
				)
			);
		} else {
			this.holder = tool.plainModal(
				h.PurchaseFormModal(this.renderForm(data.message.get("request")))
			);
		}

		this.holder.show();
	}

	makePurchase(btn) {
		dom.disable(btn);

		let type = dom.get(`[data-mpesa-type='true'].active`);
		let key = type.dataset.mpesaValue;

		let message = {};
		message.type = key;
		message[key] = dom.id(`mpesa-purchase-${key}-input`)?.value;

		if (key == "paybill") {
			message.account_number = dom.id(
				`mpesa-purchase-paybill-account-input`
			)?.value;
		}

		let offline = dom.id("purchase-type-switch");

		if (offline.checked) {
			message.method = "offlineMpesa";
			message.offline_transaction_id =
				dom.id("offline-transaction-id")?.value ?? null;
		} else {
			message.method = "mpesa";
		}

		const selectedItems = dc.selectedItems.value;
		let requiresLocation = false;
		for (let itemId in selectedItems) {
			const isSomewhereElse = dc.buyFromSomewhereElse.value[itemId] === true;
			const buyAnother = dc.buyAnotherItem.value[itemId] === true;
			if (isSomewhereElse && !buyAnother) {
				requiresLocation = true;
				break;
			}
		}

		if (requiresLocation) {
			let lat = dom.id("puf-latitude");
			let lng = dom.id("puf-longitude");

			if (empty(lat.value) || empty(lng.value)) {
				dom.enable(btn);
				return inform(
					"Please select your purchase location",
					STRINGS.ERROR
				);
			}

			message.latitude = lat.value;
			message.longitude = lng.value;
		}
		h.Spinner({ parent: btn, resetParent: true });
		broker.send($e.purchase.needs.storage, payload(message));
	}

	getFinalAmount() {
		let items = dc.selectedItems.value;
		let amount = 0;

		for (let k in items) {
			let item = items[k];
			let price = dc.purchasePrices.value[k] ?? item.price;
			amount += Number(price) * Number(item.quantity);
		}

		return amount;
	}

	addAmount() {
		let elem = dom.id("purchase-add-subtract-amount-input");
		let value = elem?.value ?? "";

		if (value.length < 1) value = 0;
		else value = Number(value);

		let sign = dom.id("purchase-add-subtract-switch");
		if (sign && sign.checked) value = -value;

		purCxt.additionalAmount.value = value;
	}

	switchType() {
		let elem = dom.id("purchase-type-switch");
		let input = dom.id("purchase-offline-with-mpesa");

		if (elem.checked) {
			input.classList.remove("d-none");
		} else {
			input.classList.add("d-none");
		}
	}

	parseTransactionId(elem) {
		if (!elem?.value) return;

		elem.value = elem.value.split(/\s+/g)[0];
	}



	showMap() {
		broker.send($e.location.is.needed, payload({}, { from: "PUR-FORM" }));
	}

	$$location = {
		is: {
			available: (ed, event) => {
				let { message, meta } = eParse(ed);

				if (meta.from != "PUR-FORM") return;

				let lat = dom.id("puf-latitude");
				let lng = dom.id("puf-longitude");
				let preview = dom.id("pf-address-preview");

				if (lat) lat.value = message.latitude;
				if (lng) lng.value = message.longitude;
				if (preview) dom.put(message.address, preview);
			},
		},
	};

	closeForm() {
		this.holder.hide();
	}
}

function PurchaseFormCanvas(...args) {
	return h.$(h.div({ class: "offcanvas-body" }, ...args));
}

function PurchaseFormModal(...args) {
	return h.$(
		h.div(
			{
				class: "modal-content border-0 rounded-5 p-3",
			},
			h.div(
				{
					class: "modal-body",
				},
				...args
			)
		)
	);
}

ojs(PurchaseForm, PurchaseFormCanvas, PurchaseFormModal);
